// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__H-SwN","name":"Header_name__2nR05","birthday":"Header_birthday__3iTKD","skeleton":"Header_skeleton__2uNfy"};